import { Skeleton } from "@circleco/compass/components/Skeleton";
import { createPortal } from "react-dom";

import { t } from "@/i18n-js/instance";

import { useActivationLoadingScreenStore } from "./activationLoadingScreenStore";

import styles from "@/react/components/shared/gradientBorder.module.css";

export const ActivationLoadingScreen = () => {
  const isVisible = useActivationLoadingScreenStore(state => state.isVisible);

  if (!isVisible) {
    return null;
  }

  return createPortal(
    <div
      className="bg-secondary fixed inset-0 z-[9999] flex flex-col p-4"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="sr-only">
        {t("version_activation_loading_screen.message")}
      </span>
      <div className="relative flex flex-1 rounded-t-2xl">
        <div className="relative flex flex-1 rounded-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]">
          <div className={styles.gradientBorderGlow} aria-hidden />
          <div className={styles.gradientBorderRing} aria-hidden />
          <div className="bg-primary relative z-[1] m-px flex flex-1 items-center justify-center overflow-hidden rounded-[11px]">
            <div className="flex w-full max-w-[612px] flex-col items-center gap-4 px-4 py-3">
              <Skeleton shape="pill" className="size-10" />
              <div className="flex w-full flex-col items-center gap-2">
                <Skeleton shape="square" className="h-[29px] w-full" />
                <Skeleton shape="square" className="h-36 w-full" />
              </div>
              <Skeleton shape="pill" className="h-[34px] w-[174px]" />
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};
